<template>
  <div class="yy-wrap">
    <div class="yy-top">
      <div class="yy-top-left">
        <div
          v-for="(item, index) in list"
          :key="'a' + index"
          :class="[{ szkfchecked: clickIndex1 == index }]"
          @click="chooseSix(index, item.code)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="yy-top-right">
        <div
          v-if="doadd"
          :class="[{ szkfchecked2: clickIndex2 == 0 }]"
          @click="operation(0)"
        >
          设置
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="yy-container">
        <img src="../assets/image/lq-bg.png" alt />
        <!-- <div> -->
        <div class="lq-wrap">
          <div class="lq-title">
            <div class="xuhao">序号</div>
            <div class="cardno">卡面号</div>
            <div class="yue">余额</div>
            <div class="yue">可用余额</div>
            <diV class="jifen">积分</diV>
            <div>会员类型</div>
            <div>有效期</div>
            <div>姓名</div>
            <div>手机号</div>
            <div class="zhuangt">生日</div>
            <div class="zhuangt" v-if="serach.type == 2">距离生日的天数</div>
            <div class="zhuangt" v-if="serach.type == 3">计次数量</div>
          </div>
          <div class="lq-contaniner">
            <transition-group name="list" tag="p">
              <div
                :class="['lq-item']"
                v-for="(item, index) in dataList"
                :key="index"
              >
                <div class="xuhao">{{ index + 1 }}</div>
                <!-- <div class="xuhao">{{item.id}}</div> -->
                <div class="cardno">{{ item.cardNo }}</div>
                <div class="yue">{{ curreny(item.amount) }}元</div>
                <div class="yue">{{ curreny(item.utilizeAmount) }}元</div>
                <div class="jifen">
                  {{ curreny(item.utilizeIntegral) }}
                </div>
                <!-- <div>{{ getMemberName(item.memberTypeId) }}</div> -->
                <div>{{ item.memberTypeName }}</div>
                <div>{{ item.validityDay }}</div>
                <!-- <div :title="item.begintime|dateYMDHMSFormat">{{ item.endtime | dateYMDHMSFormat}}</div>                 -->
                <div>{{ item.name }}</div>
                <div>{{ item.mobile }}</div>
                <div class="zhuangt">{{ item.birthday }}</div>
                <div class="zhuangt" v-if="serach.type == 2">
                  {{ item.birthdayCount }}
                </div>
                <div class="zhuangt" v-if="serach.type == 3">
                  {{ item.memberCount }}
                </div>
              </div>
            </transition-group>
            <div class="footer">
              <el-pagination
                @size-change="onPaginationSize"
                @current-change="onPaginationIndex"
                :current-page="serach.offset"
                :page-size="serach.limit"
                layout=" prev, pager, next,jumper,total"
                :total="maxcount"
              >
              </el-pagination>
              <!-- <div class="page-bar">
                <a v-if="serach.offset !== 1" class="banclick" @click="changePage('up')">«</a>
                <a
                  v-for="(item,index) in pages"
                  :class="{ active: serach.offset == item.pnum }"
                  :key="index"
                  v-show="item.show"
                  @click="changePage(item.pnum)"
                >{{ item.pval }}</a>
                <a v-if="serach.offset != totalPage && totalPage > 1" @click="changePage('next')">»</a>
                <b style="margin-left: 5em">
                  共
                  <i>{{ serach.offset }} / {{ totalPage }}</i>页
                </b>
                <b style="margin-left: 1em">
                  共
                  <i>{{ maxcount }}</i>条
                </b>
              </div> -->
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </transition>
  </div>
</template>

<script>
import { getRequest, postRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      clickIndex1: null,

      list: [
        { name: "有效期", code: 1 },
        { name: "生日", code: 2 },
        { name: "计次低于", code: 3 },
        { name: "消费超限", code: 4 },
        { name: "余额低于", code: 5 },
        { name: "积分超限", code: 6 },
        { name: "积分过期", code: 7 },
      ],
      dataList: [],
      dosee: false,
      doadd: false,
      doupdate: false,
      dodelete: false,
      serach: { limit: 10, offset: 1, type: null },
      pages: [],
      totalPage: 0, //总页码
      maxcount: 0,
    };
  },
  computed: {
    // list() {
    //
    //   return this.$store.state.kfszRights;
    // },
    clickIndex2() {
      return this.$store.state.operationIndex;
    },
    tMemberSet() {
      return this.$store.state.tMemberSet;
    },
  },
  watch: {
    tMemberSet(val) {
      if (val) {
        this.chooseSix(0, this.list[0].code);
      }
    },
  },
  created() {
    //
    this.checkPower();
    this.chooseSix(0, this.list[0].code);
  },
  components: {},
  methods: {
    checkPower() {
      // 权限
      if (!this.power.checkedpower("0809001")) {
        this.$router.push("/power");
      }
      this.doadd = this.power.checkedpower("0809002");
    },
    onPaginationSize(Sizeval) {
      this.serach.limit = Sizeval;
      this.getData();
    },
    // 页数
    onPaginationIndex(Indexpage) {
      this.serach.offset = Indexpage;
      this.getData();
    },
    getpage() {
      this.pages = [];
      this.totalPage = Math.ceil(this.maxcount / this.serach.limit);

      if (this.totalPage > 7) {
        let first = {};
        first.pnum = "upmore";
        first.pval = "...";

        if (this.serach.offset > 3) {
          this.firsrmore = true;
        } else {
          this.firsrmore = false;
        }
        first.show = this.firsrmore;
        this.pages.push(first);
      }

      for (var i = 1; i <= this.totalPage; i++) {
        let pagenum = {};
        pagenum.pnum = i;
        pagenum.pval = i;
        if (i == this.totalPage) {
          if (this.totalPage > 7) {
            let end = {};
            end.pnum = "downmore";
            end.pval = "...";
            if (this.serach.offset < this.totalPage - 2) {
              this.endmore = true;
            } else {
              this.endmore = false;
            }
            end.show = this.endmore;
            this.pages.push(end);
          }
          pagenum.show = true;
        } else {
          if (this.totalPage > 7) {
            if (
              i == this.serach.offset ||
              i == this.serach.offset - 1 ||
              i == this.serach.offset - 2 ||
              i == this.serach.offset + 1 ||
              i == this.serach.offset + 2
            ) {
              pagenum.show = true;
            } else {
              pagenum.show = false;
            }
          } else {
            pagenum.show = true;
          }
        }

        this.pages.push(pagenum);
      }
    },
    changePage(page) {
      if (this.serach.offset > 0 && this.serach.offset <= this.pages.length) {
        if (page == "next") {
          this.serach.offset++;
        } else if (page == "up") {
          this.serach.offset--;
        } else if (page == "upmore") {
          if (this.serach.offset - 5 > 0) {
            this.serach.offset -= 5;
          } else {
            this.serach.offset = 1;
          }
        } else if (page == "downmore") {
          if (this.serach.offset + 5 < this.totalPage) {
            this.serach.offset += 5;
          } else {
            this.serach.offset = this.totalPage;
          }
        } else {
          this.serach.offset = page;
        }

        this.getpage();
        this.getData();
      }
    },
    getData() {
      let loadingInstance = this.$loading({ text: "会员数据加载中..." });
      postRequest("/tMemberInfo/selectInfoFromSet", this.serach).then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
        if (res.status == 200) {
          this.dataList = res.data;
          this.maxcount = res.count;
          this.$store.state.tMemberSet = false;
          this.getpage();
        } else {
          this.$mymessage({
            content: res.message,
            type: "error",
            time: 3000,
            hasClose: true,
          });
        }
      });
    },
    chooseSix(index, code) {
      this.clickIndex1 = index;
      this.serach.offset = 1;
      this.serach.type = code;
      this.getData();
    },

    curreny(data) {
      data = Number(data).toFixed(2);
      return data;
    },
    operation(index) {
      if (index == 0) {
        this.$store.state.operationIndex = index;

        this.$tixing({});
      }
    },
  },
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.yy-wrap {
  width: 100%;
  height: 100%;
  z-index: 99;
  position: relative;
  overflow: hidden;
}
.yy-top {
  width: 100%;
  height: 7%;
  padding: 0 2%;
  /* background: red; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2%;
}
.yy-top-left {
  /* width: 50%; */
  height: 90%;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  border-radius: 7px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.8em;
  color: #575f6b;
  padding: 0 1%;
  /* background: red; */
}
.yy-top-left div {
  width: 6em;
  height: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;

  cursor: pointer;
}
.yy-top-right div {
  /* width: 30%; */
  height: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}
.szkfchecked,
.szkfchecked2 {
  background: url(../assets/image/lq-bg2.png);
  color: #fb7a01;
  background-size: 100% 100%;
  font-weight: bolder;
}
.yy-top-right {
  /* width: 20%; */
  height: 90%;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  border-radius: 7px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.8em;
  color: #575f6b;
  padding: 0 1%;
}
.yy-top-right > div {
  cursor: pointer;
  width: 6em;
}
.yy-container {
  width: 100%;
  height: 95%;
  margin: 0 0 0;
  position: absolute;
  top: 8%;
}
.yy-container img {
  width: 102%;
  height: 100%;
  left: -1%;
  position: absolute;
}
.yy-container > div {
  position: absolute;
  top: 15px;
  width: 100%;
  height: 100%;
  padding: 2.5% 3%;
  overflow: hidden;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s;
}
.fade-enter {
  transform: translateX(100%);
  opacity: 0;
}
.fade-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
.lq-wrap {
  width: 33%;
  height: 100%;
  padding: 2%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.lq-title {
  width: 100%;
  display: flex;
  flex-shrink: 0;
}
.lq-title div {
  width: 20%;
  text-align: center;
  color: #2c3036;
  font-size: 0.8em;
  line-height: 3.2em;
}

.lq-contaniner {
  color: #6d798e;
  font-size: 14px;
  flex: 1;
  overflow: auto;
}
.lq-item {
  display: flex;
  width: 100%;
  border: 1px solid #e7f0ff;
  cursor: pointer;
}
.lq-item div {
  width: 20%;
  text-align: center;
  line-height: 3em;
}

.lqchecked {
  box-shadow: 3px 3px 4px #a0bdee inset, -3px -3px 4px white inset;
  border: 1px solid #1471fe;
  border-radius: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(100%);
}
.list-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}
.footer {
  /* width: 100%; */
  align-items: center;
  cursor: pointer;
  position: absolute;
  bottom: 9%;
  right: 80px;
}
.page-bar {
  width: 100%;
  height: 30px;
  text-align: center;
}

.active {
  background-color: #1471fe;
  color: #fff;
  border-radius: 100%;
}
a {
  border: 0px solid #ddd;
  text-decoration: none;
  position: relative;
  cursor: pointer;
  width: 2em;
  height: 2em;
  display: inline-block;
  line-height: 2em;
  margin: 0 0.2em;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}
.page-bar a:hover {
  background-color: #1471fe;
  color: #fff;
  border-radius: 100%;
}
.page-bar a.banclick {
  cursor: not-allowed;
}
.page-bar .active a {
  color: #fff;
  cursor: default;
  color: #428eff;
  /* background-color: #1471fe;
  border-color: #1471fe; */
}
.page-bar i {
  font-style: normal;
  color: #428eff;
  margin: 0px 4px;
  font-size: 14px;
}
>>> .el-pager li {
  background-color: #e7f0ff !important ;
}
>>> .el-pagination button {
  background-color: #e7f0ff;
}
>>> .el-pagination__total {
  margin: 0 15px;
}
>>> .el-pager li.active {
  color: #1471fe !important;
  cursor: default;
}
</style>